<template>
    <!-- Componente antiguo del simulador de calculadoras (no se usa actualmente)  -->
    <!-- Para revisar el nuevo componente ir a RequestQuoteF2 -->
    <div
        class="container request-quote"
        :class="{ 'min-h-screen': !isIframe }"
    >
        <div
            v-show="loadingQuote"
            class="text-center"
        >
            <div class="lds-dual-ring mx-auto mt-32 lg:mt-48"></div>
            <p class="text-light-blue">Calculando...</p>
        </div>
        <div
            class="simulator"
            v-show="showSimulator"
        >
            <div
                v-if="!isIframe"
                class="return my-4"
            >
                <a :href="`${url}/${webpage}/modelos/configura-una-version/${modelUrl}/${versionUrl}/${modelYear}`">
                    <i
                        class="border-solid border-black inline-block p-1 mr-1"
                        style="border-width: 0 2px 2px 0; transform: rotate(135deg);"
                    ></i>
                    <p class="inline-block text-sm">Regresar</p>
                </a>
            </div>
            <div>
                <h1 class="font-medium text-2xl lg:text-3xl mb-3">Solicitar Cotización</h1>
                <p>Aquí podrás solicitar una cotización y simular un financimiento para la compra de tu vehículo.</p>
                <!-- <p>Por favor completa los siguientes campos.</p> -->
                <p class="text-sm mt-3 lg:text-right"><span class="text-light-blue">*</span>Campos requeridos</p>
                <div class="line border-solid border-b border-gray3 my-4"></div>
            </div>
            <div class="mt-8">
                <h4 class="text-lg font-medium">Detalles del vehículo</h4>
                <p>Éste es el vehículo que elegiste:</p>
                <div class="flex flex-wrap md:flex-no-wrap mt-4 lg:text-lg">
                    <div class="bg-light-brown text-center py-4 px-2 lg:p-6 w-full md:w-1/3 h-32 lg:h-48">
                        <p class="font-medium">Marca / Modelo / Versión</p>
                        <p class="mt-3 lg:mt-4">{{ `${modelName} ${versionName}` }}</p>
                    </div>
                    <div
                        class="bg-light-brown text-center py-4 px-2 lg:p-6 w-full md:w-1/3 h-32 lg:h-48 lg:mx-5 mt-4 md:mt-0 md:ml-2">
                        <p class="font-medium">Año</p>
                        <p class="mt-3 lg:mt-4">{{ modelYear }}</p>
                    </div>
                    <div
                        class="bg-light-brown text-center py-4 px-2 lg:p-6 w-full md:w-1/3 h-32 lg:h-48 mt-4 md:mt-0 md:ml-2">
                        <p class="font-medium">Costo del vehículo</p>
                        <p class="mt-3 lg:mt-4">${{ formatPrice(parseInt(versionPrice)) }}</p>
                    </div>
                </div>
            </div>
            <div
                v-if="isIframe"
                class="mt-8"
            >
                <h4 class="text-lg font-medium">Selecciona un distribuidor</h4>
                <subsidiary-select
                    redirect="false"
                    @sub-selected="changeSubData"
                ></subsidiary-select>
            </div>
            <!-- <div class="mt-8">
                <h4 class="text-lg font-medium">2. Selecciona tu estado</h4>
                <select
                    name="city" id="city" class="mt-4 h-8 w-56 pl-1 border border-solid border-light-gray bg-white"
                    v-model.number="state">
                    <option value="0" disabled selected>-Selecciona una opción-</option>
                    <option v-for="state in states" :key="state.id" :value="state.id">{{state.name}}</option>
                </select>
            </div> -->
            <!-- <div class="mt-16 text-center">
                <h3 class="font-medium text-lg">¿Quieres calcular el financiamiento de tu automóvil con <a class="text-light-blue underline" href="">BBVA</a> o <a class="text-light-blue underline" href="">CETELEM</a>?</h3>
            </div> -->
            <div class="mt-10">
                <h4 class="text-lg font-medium">Ingresa el enganche y plazo para tu vehículo:</h4>
                <p class="text-light-blue text-sm">La cantidad debe ser menor a ${{ formatPrice(maxDownpayment) }} y
                    mínimo de ${{ formatPrice(minDownpayment) }}</p>
                <div class="downpayment mt-4">
                    <p class="text-sm font-medium">Enganche:</p>
                    <currency-input v-model="downpayment"></currency-input>
                </div>
                <div class="instalments mt-6">
                    <p class="text-sm font-medium">Plazos:</p>
                    <div class="mt-6 relative">
                        <img
                            class="w-12 instalment-car relative"
                            :src="`${url}/images/icons/instalment_car_icon.png`"
                            alt="Carrito de enganche"
                        >
                        <div class="line mt-2 w-full border-solid border-b-4 border-light-blue rounded-sm"></div>
                        <div class="circles absolute -mt-2 w-full flex justify-between px-4">
                            <div
                                v-for="(instalment, index) in instalments"
                                :key="index"
                                @click="changeInstalment(index)"
                                :class="`instalment-${index} cursor-pointer`"
                            >
                                <div
                                    class="circle h-3 w-3 border-solid border-2 border-light-blue rounded-full bg-white"
                                    :class="{ 'bg-light-blue2': instSelected === index }"
                                ></div>
                                <p class="text-sm mt-1">{{ instalment }}</p>
                            </div>
                        </div>
                    </div>
                    <div class="text-center">
                        <button
                            class="w-64 lg:w-40 text-center bg-dark-blue text-white text-sm py-2 mx-auto mt-24"
                            :class="{ 'bg-opacity-50': loadingButton, 'cursor-default': loadingButton }"
                            :disabled="loadingButton"
                            @click="calculateQuotes()"
                        >
                            {{ loadingButton ? 'Calculando...' : 'Calcular' }}
                        </button>
                    </div>
                    <!-- <div class="text-sm text-light-blue">
                        <p>El pago mensual no incluye IVA ni comisiones.</p>
                        <p>CAT 18.5 Sin IVA. Informativo. Fecha de cálculo al 30 de Noviembre de 2020. Vigencia de la oferta al 31 de Diciembre de 2020.</p>
                        <p>Tasa de Interés fija del 15.99% anual.</p>
                    </div> -->
                </div>
            </div>
            <div
                class="quotations mt-10"
                id="quotations"
                v-show="showQuotations"
            >
                <div class="line border-solid border-b border-gray3 my-4"></div>
                <h3 class="font-medium text-2xl text-center mt-8 leading-snug">A continuación te presentamos algunas
                    opciones de financiamiento</h3>
                <bbva-quotation
                    v-show="showBbvaQuotation"
                    :instalments="instalments"
                    :inst-selected="instToBbva"
                    :bbva-quotation="bbvaQuotation"
                    :version-id="versionId"
                    :subsidiary="subsidiary"
                    :is-iframe="isIframe"
                    @bad-instalment="badInstalment('bbva')"
                    @charge-bbva-form="chargeBbvaForm"
                >
                </bbva-quotation>
                <div
                    class="text-center mt-10 text-light-blue"
                    v-show="loadingBbvaQuotation"
                >Calculando con BBVA...</div>
                <cetelem-quotation
                    v-show="showCetelemQuotation"
                    :instalments="instalments"
                    :inst-selected="instToCetelem"
                    :cetelem-quotation="cetelemQuotation"
                    :version-id="versionId"
                    :subsidiary="subsidiary"
                    :is-iframe="isIframe"
                    @bad-instalment="badInstalment('cetelem')"
                    @charge-cetelem-form="chargeCetelemForm"
                >
                </cetelem-quotation>
                <div
                    class="text-center mt-10 text-light-blue"
                    v-show="loadingCetelemQuotation"
                >Calculando con CETELEM...</div>
            </div>
        </div>
        <bbva-form
            v-if="showBbvaForm"
            :subsidiary="subsidiary"
            :sub-name="subName"
            :model-name="modelName"
            :version-id="versionId"
            :version-name="versionName"
            :version-price="versionPrice"
            :model-year="modelYear"
            :term="instalments[instSelected]"
            :pago-mensual="bbvaQuotData.pagoMensual"
            :monto-total="bbvaQuotData.montoTotal"
            :total-pagar="bbvaQuotData.totalAPagar"
            :enganche="downpayment"
            :seguro="bbvaQuotData.seguro"
            :app-env="appEnv"
            :is-iframe="isIframe"
        >
        </bbva-form>
        <!-- <cetelem-form
            v-if="showCetelemForm"
            :subsidiary="subsidiary"
            :sub-name="subName"
            :model-name="modelName"
            :version-name="versionName"
            :model-year="modelYear"
            :term="instalments[instSelected]"
            :pago-mensual="cetelemQuotData.pagoMensual"
            :monto-total="cetelemQuotData.montoTotal"
            :total-pagar="cetelemQuotData.totalAPagar"
            :id-aseguradora="cetelemQuotData.idAseguradora"
            :id-plan="cetelemQuotData.idPlan"
            :enganche="downpayment"
            :cetelem-data="cetelemData"
            :app-env="appEnv"
            :is-iframe="isIframe"
        >
        </cetelem-form> -->
    </div>
</template>

<script>
import Swal from "sweetalert2";
export default {
    props: [
        "modelId",
        "versionId",
        "modelName",
        "modelUrl",
        "versionName",
        "versionUrl",
        "modelYear",
        "versionPrice",
        "subData",
        "states",
        "appEnv",
        "isIframe",
        "queryParams",
    ],
    data() {
        return {
            url: $(".url").text(),
            webpage: $(".webpage").text(),
            instalments: [12, 24, 36, 48, 60, 72],
            instSelected: 0,
            instToCetelem: null,
            instToBbva: null,
            downpayment: 0,
            subsidiary: this.subData.caption_text,
            subName: this.subData.name,
            state: this.subData.geo_state_id,
            bbvaSimulation: {
                insu: {
                    t12: {},
                    t24: {},
                    t36: {},
                    t48: {},
                    t60: {},
                    t72: {},
                },
                noInsu: {
                    t12: {},
                    t24: {},
                    t36: {},
                    t48: {},
                    t60: {},
                    t72: {},
                },
            },
            bbvaQuotation: {
                insu: {},
                noInsu: {},
            },
            cetelemQuotation: {},
            showSimulator: true,
            showQuotations: false,
            showBbvaQuotation: false,
            showCetelemQuotation: false,
            loadingQuote: false,
            loadingBbvaQuotation: false,
            loadingCetelemQuotation: false,
            recalcQuote: true,
            badCetelemInst: false,
            badBbvaInst: false,
            bbvaQuotErrs: [],
            showBbvaForm: false,
            showCetelemForm: false,
            bbvaQuotData: {},
            cetelemQuotData: {},
            cetelemData: {},
        };
    },
    watch: {
        downpayment: function (val) {
            if (this.showQuotations) {
                this.showQuotations = false;
                this.showBbvaQuotation = false;
                this.showCetelemQuotation = false;
            }
            this.recalcQuote = true;
        },
        instSelected: function (val) {
            if (this.showQuotations) {
                this.showQuotations = false;
            }
        },
        showQuotations: function (val) {
            if (val) {
                this.$nextTick(function () {
                    let quotsTop = document
                        .getElementById("quotations")
                        .getBoundingClientRect().top;
                    $("html, body").animate(
                        {
                            scrollTop: quotsTop + $(window).scrollTop(),
                            // scrollTop: bbvaTop - 40 - 68
                        },
                        1000
                    );
                });
            } else {
                // hide chart
            }
        },
        // bbvaSimulation: {
        //     handler: function(newVal) {
        //         let someInsuEmpty = false
        //         let someNoInsuEmpty = false

        //         let numInsuTermsFalse = 0
        //         let numNoInsuTermsFalse = 0

        //         for (const term in newVal.insu) {
        //             if ($.isEmptyObject(newVal.insu[term])) {
        //                 someInsuEmpty = true
        //             } else if (!newVal.insu[term].success) {
        //                 numInsuTermsFalse++
        //             }
        //         }

        //         for (const term in newVal.noInsu) {
        //             if ($.isEmptyObject(newVal.noInsu[term])) {
        //                 someNoInsuEmpty = true
        //             } else if (!newVal.noInsu[term].success) {
        //                 numNoInsuTermsFalse++
        //             }
        //         }

        //         // Si alguno de los dos objetos no está vacío lo envía al componente BbvaQuotation
        //         if ((!someInsuEmpty && !someNoInsuEmpty) && (numInsuTermsFalse < 6 && numNoInsuTermsFalse < 6)) {
        //             // Si no está vacío el objeto con seguro se asegura que no todos los plazos estén en success = false
        //             if (!someInsuEmpty) {
        //                 this.bbvaQuotation.insu = newVal.insu
        //             }

        //             if (!someNoInsuEmpty) {
        //                 this.bbvaQuotation.noInsu = newVal.noInsu
        //             }

        //             this.instToBbva = this.instSelected
        //             this.showBbvaQuotation = true
        //             this.loadingQuote = false
        //             this.showSimulator = true
        //             this.showQuotations = true
        //             this.recalcQuote = false
        //             this.loadingBbvaQuotation = false

        //         } else if (numInsuTermsFalse === 6 && numNoInsuTermsFalse === 6) {
        //             // this.showSwalError('Hubo un problema en tu Simulación con BBVA Consumer Finance', "Inténtalo de nuevo más tarde")
        //             // this.loadingQuote = false
        //             // this.showQuotations = true
        //             // this.recalcQuote = false
        //             this.loadingBbvaQuotation = false

        //             if (!this.loadingCetelemQuotation && $.isEmptyObject(this.cetelemQuotation)) {
        //                 this.showSwalError('Hubo un problema al procesar tu solicitud', "Por el momento, el vehículo que seleccionaste no está disponible. Elige otro e inténtalo de nuevo.")
        //             }
        //         }
        //     },
        //     deep: true
        // }
    },
    methods: {
        formatDate(date) {
            let dd = date.getDate().toString().padStart(2, "0");
            let mm = (date.getMonth() + 1).toString().padStart(2, "0");
            let yyyy = date.getFullYear();
            return `${yyyy}-${mm}-${dd}`;
        },
        formatPrice(price, n, x) {
            let re =
                "\\d(?=(\\d{" + (x || 3) + "})+" + (n > 0 ? "\\." : "$") + ")";
            return parseInt(price)
                .toFixed(Math.max(0, ~~n))
                .replace(new RegExp(re, "g"), "$&,");
        },
        changeInstalment(index) {
            if (!this.loadingCetelemQuotation && !this.loadingBbvaQuotation) {
                let instPos = $(".instalment-" + index).position();
                $(".instalment-car").css("left", instPos.left - 17);
                this.instSelected = index;
            }
        },
        badInstalment(provider) {
            if (provider === "cetelem") {
                this.badCetelemInst = true;
                this.showCetelemQuotation = false;
                // this.instToCetelem = null
            }

            if (provider === "bbva") {
                this.badBbvaInst = true;
                this.showBbvaQuotation = false;
                // this.instToBbva = null
            }

            if (this.badCetelemInst && this.badBbvaInst) {
                this.showQuotations = false;
                // this.showCetelemQuotation = false
                // this.instToQuote = 0
                // this.changeInstalment(0)
                // this.recalcQuote = true
                this.showSwalError(
                    "Plazo no disponible",
                    "<p>El plazo seleccionado no está disponible, selecciona otro para continuar.</p>"
                );
            } else if (this.badCetelemInst) {
                if (
                    !this.loadingBbvaQuotation &&
                    this.bbvaQuotErrs.length === 12
                ) {
                    this.showQuotations = false;
                    this.showSwalError(
                        "Plazo no disponible",
                        "<p>El plazo seleccionado no está disponible, selecciona otro para continuar.</p>"
                    );
                } else {
                    this.showSwalError(
                        "Plazo no disponible",
                        "<p>El plazo seleccionado no está disponible para CETELEM, consulta con BBVA.</p>"
                    );
                }
            } else if (this.badBbvaInst) {
                if (
                    !this.loadingCetelemQuotation &&
                    $.isEmptyObject(this.cetelemQuotation)
                ) {
                    this.showQuotations = false;
                    this.showSwalError(
                        "Plazo no disponible",
                        "<p>El plazo seleccionado no está disponible, selecciona otro para continuar.</p>"
                    );
                } else {
                    this.showSwalError(
                        "Plazo no disponible",
                        "<p>El plazo seleccionado no está disponible para BBVA, consulta con CETELEM.</p>"
                    );
                }
            }
        },
        showSwalError(title, msg, reload = false) {
            Swal.fire({
                icon: "error",
                title: `<h3 class="text-2xl leading-tight font-medium">${title}</h3>`,
                html: msg,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton:
                        "text-center bg-dark-blue text-white w-64 lg:w-40 text-sm py-2",
                },
                buttonsStyling: false,
            }).then((result) => {
                if (reload) {
                    window.location.reload();
                }
            });
        },
        changeSubData(sub) {
            console.log(sub);
            if (this.showQuotations) {
                this.showQuotations = false;
            }
            this.recalcQuote = true;
            this.subsidiary = sub.caption_text;
            this.subName = sub.name;
            this.state = sub.geo_state_id;
        },
        calculateBbvaQuote() {
            this.bbvaQuotErrs = []; // Variable para guardar los errores que arroje el API
            let numInsuResp = 0; // Variable para determinar el número de respuestas con seguro
            let noInsuResp = false; // Variable para determinar si hay respuesta de BBVA sin seguro

            // Envía una petición por cada plan_term con seguro
            for (let i = 12; i <= 72; i += 12) {
                axios
                    .post(`${this.url}/bbva/calcular-cotizacion`, {
                        pt_id: this.versionId,
                        enganche: this.downpayment,
                        year: this.modelYear,
                        plan_term: i,
                        seguro: true,
                    })
                    .then((resp) => {
                        if (!this.showCetelemForm) {
                            console.log(
                                "/bbva/calcular-cotizacion/insu/" + i,
                                resp
                            );
                            if (resp.data.success) {
                                this.bbvaSimulation.insu["t" + i] =
                                    resp.data.data.installments[0];
                                this.bbvaSimulation.insu[
                                    "t" + i
                                ].success = true;
                            } else {
                                this.bbvaSimulation.insu["t" + i] = {
                                    success: false,
                                };
                                this.bbvaQuotErrs.push(resp.data.errors);
                            }
                            numInsuResp++;
                            if (numInsuResp === 6 && noInsuResp) {
                                this.showBbvaResp();
                            }
                        }
                    });
            }

            // Envía una petición general para todos los plan_term sin seguro
            axios
                .post(`${this.url}/bbva/calcular-cotizacion`, {
                    pt_id: this.versionId,
                    enganche: this.downpayment,
                    year: this.modelYear,
                    plan_term: 0,
                    seguro: false,
                })
                .then((resp) => {
                    if (!this.showCetelemForm) {
                        console.log("/bbva/calcular-cotizacion/noInsu/", resp);
                        if (resp.data.success) {
                            let installments = resp.data.data.installments;
                            let x = 0;
                            for (let i = 12; i <= 72; i += 12) {
                                if (installments[x]) {
                                    this.bbvaSimulation.noInsu["t" + i] =
                                        installments[x];
                                    this.bbvaSimulation.noInsu[
                                        "t" + i
                                    ].success = true;
                                } else {
                                    this.bbvaSimulation.noInsu["t" + i] = {
                                        success: false,
                                    };
                                    this.bbvaQuotErrs.push("Error plazo " + i);
                                }
                                x++;
                            }
                        } else {
                            for (let i = 12; i <= 72; i += 12) {
                                this.bbvaSimulation.noInsu["t" + i] = {
                                    success: false,
                                };
                                this.bbvaQuotErrs.push("Error plazo " + i);
                            }
                        }
                        noInsuResp = true;
                        if (numInsuResp === 6 && noInsuResp) {
                            this.showBbvaResp();
                        }
                    }
                });
        },
        showBbvaResp() {
            if (this.bbvaQuotErrs.length < 12) {
                this.bbvaQuotation.insu = this.bbvaSimulation.insu;
                this.bbvaQuotation.noInsu = this.bbvaSimulation.noInsu;

                this.instToBbva = this.instSelected;
                this.showBbvaQuotation = true;
                this.loadingQuote = false;
                this.showSimulator = true;
                this.showQuotations = true;
                this.recalcQuote = false;
                this.loadingBbvaQuotation = false;
            } else {
                // this.showSwalError('Hubo un problema en tu Simulación con BBVA Consumer Finance', "Inténtalo de nuevo más tarde")
                // this.loadingQuote = false
                // this.showQuotations = true
                // this.recalcQuote = false
                this.loadingBbvaQuotation = false;

                if (
                    !this.loadingCetelemQuotation &&
                    $.isEmptyObject(this.cetelemQuotation)
                ) {
                    this.showSwalError(
                        "Hubo un problema al procesar tu solicitud",
                        "Por el momento, el vehículo que seleccionaste no está disponible. Elige otro e inténtalo de nuevo.",
                        true
                    );
                }
            }
        },
        calculateCetelemQuote() {
            axios
                .post(`${this.url}/cetelem/calcular-cotizacion`, {
                    pt_id: this.versionId,
                    pdvIdMarca: this.subsidiary,
                    estado: parseInt(this.state),
                    enganche: this.downpayment,
                })
                .then((resp) => {
                    console.log("/cetelem/calcular-cotizacion", resp);
                    if (!this.showBbvaForm) {
                        // if (resp.data.success) {
                        // if (true) {
                        if (
                            resp.data.success &&
                            resp.data.data.quotation.planes[0].termsXAseguradora
                                .length > 0
                        ) {
                            this.cetelemQuotation = resp.data.data.quotation;
                            this.cetelemData = resp.data.cetelemData;
                            this.instToCetelem = this.instSelected;
                            this.loadingQuote = false;
                            this.showSimulator = true;
                            this.showQuotations = true;
                            this.showCetelemQuotation = true;
                            this.recalcQuote = false;
                            this.loadingCetelemQuotation = false;
                        } else {
                            this.loadingCetelemQuotation = false;
                            if (
                                !this.loadingBbvaQuotation &&
                                this.bbvaQuotErrs.length === 12
                            ) {
                                this.loadingQuote = false;
                                this.recalcQuote = true;
                                this.showSwalError(
                                    "Hubo un problema al procesar tu solicitud",
                                    "Por el momento, el vehículo que seleccionaste no está disponible. Elige otro e inténtalo de nuevo.",
                                    true
                                );
                            }
                            // this.showSwalError('Hubo un problema en tu Simulación con CETELEM', '<p>Inténtalo de nuevo más tarde</p>')
                        }
                        // }
                        // else {
                        //     this.loadingCetelemQuotation = false
                        //     if (!this.loadingBbvaQuotation && this.bbvaQuotErrs.length === 12) {
                        //         this.loadingQuote = false
                        //         this.recalcQuote = true
                        //         this.showSwalError('Hubo un problema al procesar tu solicitud', "Por el momento, el vehículo que seleccionaste no está disponible. Elige otro e inténtalo de nuevo.", true)
                        //     }
                        //     // this.showSwalError('Hubo un problema en tu Simulación con CETELEM', '<p>Inténtalo de nuevo más tarde</p>')
                        // }
                    }
                })
                .catch((error) => {
                    this.loadingQuote = false;
                    if (error.response) {
                        // Request made and server responded
                        console.log(error.response.data);
                        // console.log(error.response.status);
                        // console.log(error.response.headers);
                        let errors = error.response.data.errors;
                        let message = "";
                        for (let error in errors) {
                            message += `<p>${errors[error]}</p>`;
                        }
                        if (
                            !this.loadingBbvaQuotation &&
                            this.bbvaQuotErrs.length === 12
                        ) {
                            this.showSwalError(
                                "Hubo un problema al procesar tu solicitud",
                                "<p>Inténtalo de nuevo más tarde.</p>",
                                true
                            );
                            this.loadingQuote = false;
                            this.showQuotations = false;
                            this.showCetelemQuotation = false;
                            this.loadingCetelemQuotation = false;
                            this.recalcQuote = true;
                        } else {
                            this.loadingCetelemQuotation = false;
                        }
                    } else if (error.request) {
                        // The request was made but no response was received
                        console.log(error.request);
                    } else {
                        // Something happened in setting up the request that triggered an Error
                        console.log("Error", error.message);
                    }
                });
        },
        calculateQuotes() {
            // Hace la llamada para calcular con CETELEM
            // Si el estado no es el default y el enganche es mayor al mínimo hace la petición
            if (this.isSubData && this.isDownpaymentCorrect) {
                // if (!this.isIframe) {
                dataLayer.push({
                    event: "calcular_financiamiento",
                    modelo: this.modelName,
                    version: this.versionName,
                    year_model: this.modelYear,
                    distribuidor: this.subName,
                    estado: this.states.find(
                        (state) => state.id === parseInt(this.state)
                    ).name,
                    enganche: this.downpayment, // número
                    plazo: this.instalments[this.instSelected] + " meses",
                });
                // }

                if (this.recalcQuote) {
                    $("html, body").animate(
                        {
                            scrollTop: 0,
                        },
                        1000
                    );

                    this.showSimulator = false;
                    this.loadingQuote = true;
                    this.showBbvaQuotation = false;
                    this.loadingBbvaQuotation = true;
                    this.showCetelemQuotation = false;

                    this.calculateBbvaQuote();

                    this.loadingCetelemQuotation = true;
                    this.calculateCetelemQuote();
                } else {
                    this.instToCetelem = this.instSelected;
                    this.instToBbva = this.instSelected;
                    this.loadingQuote = false;
                    this.showSimulator = true;
                    this.showQuotations = true;
                    this.showCetelemQuotation = !$.isEmptyObject(
                        this.cetelemQuotation
                    )
                        ? true
                        : false;
                    this.showBbvaQuotation =
                        this.bbvaQuotErrs.length < 12 ? true : false;
                    this.loadingBbvaQuotation = false;
                    this.loadingCetelemQuotation = false;
                }
            } else {
                let message = "";
                if (!this.isSubData) {
                    message += "<p>Debes seleccionar un distribuidor</p>";
                }
                if (!this.isDownpaymentCorrect) {
                    if (this.downpayment < this.minDownpayment)
                        message += `<p>El enganche debe ser mínimo de $${this.formatPrice(
                            this.minDownpayment
                        )}</p>`;
                    else if (this.downpayment > this.maxDownpayment)
                        message += `<p>El enganche debe ser menor a $${this.formatPrice(
                            this.maxDownpayment
                        )}</p>`;
                }
                this.showSwalError("Datos requeridos", message);
            }
        },
        chargeBbvaForm(quotData) {
            this.bbvaQuotData = quotData;
            this.showSimulator = false;
            this.showBbvaForm = true;
            $("html, body").animate(
                {
                    scrollTop: 0,
                },
                2000
            );
        },
        chargeCetelemForm(quotData) {
            this.cetelemQuotData = quotData;
            this.showSimulator = false;
            this.showCetelemForm = true;
            $("html, body").animate(
                {
                    scrollTop: 0,
                },
                2000
            );
        },
    },
    computed: {
        minDownpayment() {
            let minDownpayment = Math.round(
                parseFloat(this.versionPrice) * 0.2,
                2
            );
            this.downpayment = minDownpayment;
            return minDownpayment;
        },
        maxDownpayment() {
            return parseFloat(this.versionPrice) - 30000;
        },
        isDownpaymentCorrect() {
            return (
                this.downpayment >= this.minDownpayment &&
                this.downpayment <= this.maxDownpayment
            );
        },
        isSubData() {
            return (
                this.subsidiary !== null &&
                this.subName !== null &&
                this.state !== null
            );
        },
        loadingButton() {
            // return (this.showBbvaQuotation && this.showCetelemQuotation) || !this.loadingQuote ? false : true
            return this.loadingBbvaQuotation || this.loadingCetelemQuotation;
        },
    },
    // mounted() {
    //     const params = new URL(parent.location.href).searchParams;
    //     const year = params.get("year");
    // },
};
</script>

<style lang="scss">

</style>
